import { ExistingPatient } from "cadendar-shared";
import { patientValidationState } from "../../patients/validators/individualValidators";
import { LocalNewPatient } from "../components/FamilleGridPanel";
const patientsValidStates = (patients: (LocalNewPatient | ExistingPatient)[]) => {
  return patients.map((patient) => patientValidationState(patient));
};

export { patientsValidStates };
